import { useState, useRef, useEffect, useCallback } from 'react';
import { authFetch } from '../auth';

const SECTIONS = '/api/cms/sections';

/**
 * 페이지 정적 문구 섹션(TB_PAGE_SECTION) 편집용 훅.
 * 한국어(dataKo)만 저장 → 서버 가드가 기존 번역(en/ja/zhTw)을 보존한다.
 *  data       : 현재 ko 데이터 객체
 *  setField   : (field, value) 한 필드 갱신
 *  saveSection: (sort) 저장(상위 save에서 await)
 */
export function useSection(page, key, sort = 1) {
  const ref = useRef({});
  const dirtyRef = useRef(false);
  const [data, setData] = useState({});

  useEffect(() => {
    let alive = true;
    authFetch(`${SECTIONS}?page=${page}&lang=ko`)
      .then((r) => r.json())
      .then((rows) => {
        const row = (rows || []).find((x) => x.key === key);
        const d = (row && row.data) || {};
        if (alive) { ref.current = d; setData(d); }
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [page, key]);

  const setField = (field, value) => {
    ref.current = { ...ref.current, [field]: value };
    dirtyRef.current = true;
    setData(ref.current);
  };

  const saveSection = useCallback(async () => {
    const res = await authFetch(SECTIONS, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page, key, type: 'ui', sort, dataKo: ref.current }),
    });
    if (!res.ok) throw new Error(`문구 저장 실패 (${res.status})`);
    dirtyRef.current = false;
  }, [page, key, sort]);

  const isDirty = useCallback(() => dirtyRef.current, []);

  return { data, setField, saveSection, isDirty };
}
